<template>
  <div>
    <!-- <modal
      title="maadsbgfgjbf"
      :show.sync="mantraVisible"
      width="30%" 
      
    >
      <AddMantras/>
    </modal> -->
    <b-card class="border-none">
      <modal :show.sync="editModal" header-classes="bg-primary p-3">
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          EDIT IMAGE ORDER
        </h6>
        <!-- <AddPageDetail /> -->
        <template slot="footer">
          <base-button type="primary">SAVE CHANGES</base-button>
          <base-button
            type="secondary"
            class="ml-auto"
            @click="editModal = false"
            >CLOSE</base-button
          >
        </template>
      </modal>

      <div class="flex justify-between items-center mb-8">
        <div>
          <h2 class="text-2xl font-semibold">Mantras</h2>

          <!-- <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small> -->
        </div>
        <div class="flex">
          <!-- <base-button
            outline
            class="px-6 py-1 mx-1"
            type="primary"
            @click="mantraVisible = true"
          >
            <span class="btn-inner--text flex justify-between items-center"
              ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon
              >Mantras</span
            >
          </base-button> -->
          <div>
            <base-button
              outline
              class="px-6 py-1 mx-1"
              type="primary"
              v-b-modal.modal-6
            >
              <span class="btn-inner--text flex justify-between items-center"
                ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon
                >Mantras</span
              >
            </base-button>

            <b-modal id="modal-6" title="Add Mantras" hide-footer>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form
                  role="form"
                  @submit.prevent="handleSubmit(handleCreate)"
                >
                  <div>
                    <b-form-group label="Add a new mantra">
                      <base-input
                        v-model="mantra"
                        placeholder="Enter input"
                        name="mantra"
                        :rules="{ required: true }"
                      ></base-input>
                    </b-form-group>
                    <div class="flex justify-center">
                      <b-button type="submit" variant="primary">Save</b-button>
                    </div>
                  </div>
                </b-form>
              </validation-observer>
            </b-modal>
          </div>
        </div>
      </div>

      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          v-model="search"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <!-- <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="applicationsession"
      >
        <el-table-column label="Sr. no" min-width="170px" prop="serial">
          <template>
            <span>1</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Description"
          prop="descpriction"
          min-width="130px"
        >
          <template>
            <span>sssssss</span>
          </template>
        </el-table-column>

        <el-table-column property="action" label="Action" width="">
          <template>
            <div class="flex items-center">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5"
                class="cursor-pointer text-primary"
              />
              <feather-icon
                svgClasses="w-5 h-5"
                class="ml-2 cursor-pointer text-danger"
                icon="Trash2Icon"
              />
            </div>
          </template>
        </el-table-column>
      </el-table> -->
      <el-table
        border
        :data="tableData"
        style="width: 100%"
        class="mt-4 rounded"
        header-row-class-name="thead-light table-th-color "
      >
        <el-table-column prop="srno" label="Sr. no" width="100">
        </el-table-column>
        <el-table-column prop="description" label="Description" width="">
          <!-- <template v-slot="{ row }">
            <p>{{ row.description }}</p>
          </template> -->
        </el-table-column>
        <el-table-column
          label="Edited By"
          prop="editedby"
          min-width="130px"
          sortable
        >
          <template v-slot="{ row }">
            <p
              class="font-semibold text-left name mb-0 text-sm"
              v-if="row.isEdited"
            >
              {{
                row.editedByName[0].firstname +
                  " " +
                  row.editedByName[0].lastname || " "
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="Action" width="100">
          <template v-slot="{ row }">
            <div class="flex items-center">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5"
                class="cursor-pointer text-primary"
                @click="handleeditModal(row)"
                v-b-modal.modal-2
              />
              <feather-icon
                svgClasses="w-5 h-5"
                class="ml-2 cursor-pointer text-danger"
                icon="Trash2Icon"
                @click="handleDelete(row)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <b-modal id="modal-2" title="Edit Mantra" hide-footer>
        <div>
          <b-form-group label="Edit Mantra">
            <b-form-input v-model="edit.description"></b-form-input>
          </b-form-group>
          <div class="flex justify-center">
            <b-button type="submit" variant="primary" @click="handleEdit"
              >Save</b-button
            >
          </div>
        </div>
      </b-modal>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <!-- <base-pagination
          v-model="currentPage"
          @change="handlePageChange"
          :per-page="10"
          :total="quote.totalCount || 0"
        ></base-pagination> -->
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
// import "../../scss/Index.scss";
import Data from "./component/Data";
import _ from "lodash";
import { mapState } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      mantraVisible: false,
      Data,
      currentPage: 1,
      totalRows: 0,
      editModal: false,
      openAddBannerSidebar: false,
      approve: false,
      perPage: 10,
      tableData: [
        {
          srno: "1",
          desc: "Tom",
        },
      ],
      mantra: "",
      edit: {},
      search: "",
    };
  },
  watch: {
    async currentPage() {
      await this.getMantras();
    },
    search: {
      handler: _.debounce(async function (val) {
        // if (val) {
        //   await this.$store.dispatch("mantra/getQuoteData", {
        //     search: this.search,
        //   });
        // } else {
        //   await this.$store.dispatch("mantra/getQuoteData");
        // }
        this.getMantras();
      }, 500),
    },
  },
  methods: {
    async getMantras() {
      // let payload = {};
      // if (this.search) Object.assign(payload, { search: this.search.trim() });
      // await this.$store.dispatch("mantra/getQuoteData", payload);
      // console.log(this.quote);

      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        // let loader = this.$loading();
        const getMantra = await this.$store.dispatch(
          "mantra/getQuoteData",
          payload
        );
        // console.log(getMantra);
        // loader.close();
        this.totalRows = this.quote.totalCount;
        let mantradata = this.quote.result;
        // console.log(mantradata);
        const mantras = mantradata.map((mantra, index) => {
          return {
            srno: index + 1 + curPage * this.perPage,
            title: mantra.title,
            _id: mantra._id,
            description: mantra.description,
            isEdited: mantra.isEdited,
            editedByName: mantra.editedByName,
          };
        });
        // console.log(notifications);
        this.tableData = mantras;
      } catch (error) {
        console.log(error);
        // loader.close();
      }
    },
    async handleCreate() {
      let payload = {
        // text: this.mantra,
        description: [this.mantra],
      };
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("mantra/AddQuote", payload);
        loader.close();

        if (data.code == 200) {
          this.$bvModal.hide("modal-6");
          await this.$swal({
            text: "Mantras Added successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          loader.close();
          this.mantra = "";
          await this.getMantras();
        }
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    handleeditModal(row) {
      this.edit = { ...row };
    },
    async handleEdit() {
      let payload = {
        _id: this.edit._id,
        description: this.edit.description,
      };
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("mantra/editQuote", payload);
        loader.close();
        if (data.code == 200) {
          this.$bvModal.hide("modal-2");
          await this.getMantras();
          await this.$swal({
            text: "Mantras Edited successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    async handlePageChange(value) {
      this.currentPage = value;
      if (this.currentPage > 1) {
        let payload = {
          offset: (this.currentPage - 1) * 10,
        };
        if (this.search) Object.assign(payload, { search: this.search });
        let loader = this.$loading();
        try {
          let data = await this.$store.dispatch("mantra/getQuoteData", payload);
          if (data.code == 200) {
            loader.close();
            // return data.data.result;
          }
          loader.close();
        } catch (error) {
          loader.close();
        }
      } else {
        await this.getMantras();
      }
    },
    async handleDelete(row) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(row);
        await this.getMantras();
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(row) {
      let payload = {
        _id: row._id,
      };
      let loader = this.$loading();
      try {
        const data = await this.$store.dispatch("mantra/removeQuote", payload);
        loader.close();
        this.getMantras();
        if (data.code == 200) {
          await this.$swal({
            text: "Mantras Deleted successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },
  },
  computed: {
    ...mapState("mantra", ["quote"]),
  },
  async mounted() {
    await this.getMantras();
  },
};
</script>
<style>
.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 1rem !important;
}
.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
</style>
